import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useAuth } from 'react-oidc-context';

import api from 'api/api';

import { File } from './types';

const fetchReports = async () => {
  const { data } = await api.get(`/files/reports`);

  return data;
};

const useReports = () => {
  const auth = useAuth();
  return useQuery<File[], AxiosError>({ queryKey: ['reports'], queryFn: fetchReports, enabled: auth.isAuthenticated });
};

export default useReports;
